(function(window) {

	function TrimLongString(string) {
		if (!string) {
			return false;
		}

		string = string.replace(/(\sja\s|\+)/ig, ', ').replace(/\s*,\s*/g, ', ');

		if(string.length >= 30) {
			string = string.substr(0, string.substr(0, 30).lastIndexOf(" "));
			string = string.trim();

			if(string[string.length - 1] == ',') {
				string = string.substr(0, string.length - 1);
			}

			string += "…";
		}
		return string;
	}

	function ScrollTo(elem, extra) {
		if (!extra) {
			$(window).scrollTop($(elem).offset().top);
		} else {
			$(window).scrollTop($(elem).offset().top - extra);
		}
	}

	window.Utils = {
		TrimLongString: TrimLongString,
		ScrollTo: ScrollTo
	};

})(window);

String.prototype.capitalize = function() {
	return this.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
};

function clamp(value, min, max) {
	return value < min ? min : (value > max ? max : value);
}